import React from 'react';
import Star from 'svg/Star';

interface InfoItemProps {
  label: string;
  value: string;
  icon?: React.ReactNode;
  subValue?: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value, icon, subValue }) => {
  return (
    <div className="typography-product-body-highlight flex flex-col items-center justify-center text-color-text-brand dark:text-color-text-brand">
      <div className="flex items-center gap-1 whitespace-nowrap">
        {icon}
        <div className="typography-product-subheading my-auto self-stretch">{value}</div>
      </div>
      <div className="typography-product-chips-filters mt-1 text-color-text-brand dark:text-color-text-brand">
        {subValue || label}
      </div>
    </div>
  );
};

export default InfoItem;
